import type React from 'react'
import {ActionList} from '@primer/react'
import {clsx} from 'clsx'

import styles from './ReferenceList.module.css'

export interface ReferenceListProps {
  /** One or more {@link ReferenceCard} elements. */
  children: React.ReactNode
  className?: string
  /** Accessible name for the list. */
  'aria-label'?: string
}

/**
 * Layout-only wrapper for a set of {@link ReferenceCard}s. Holds no data — it
 * only groups the cards into a single bordered, panel-style container with row
 * dividers, so the spacing/layout of a reference list lives in one place.
 */
export function ReferenceList({children, className, 'aria-label': ariaLabel}: ReferenceListProps) {
  return (
    <ActionList showDividers variant="full" aria-label={ariaLabel} className={clsx(styles.list, className)}>
      {children}
    </ActionList>
  )
}
